import React from "react";
import axios from "../../../../containers/api";
import {
  Alert,
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import { showCatchError, toEnglishNumbers } from "../../../../helpers/Utils";

class profile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      TransportationCompany: [],
      ProductOwner: [],
      Driver: [],
      errors: [],
    };
    console.log(this.props);
  }

  componentDidMount() {
    if (this.props.memberType.role === "TransportationCompanyAdmin")
      this.GetByTransportationCompanyId();
    else if (this.props.memberType.role === "ProductOwnerAdmin")
      this.GetByProductOwnerId();
    else if (this.props.memberType.role === "Driver") this.GetDriverbyId();
  }

  componentWillMount() {}

  GetByTransportationCompanyId = () => {
    this.props.showSpinner();
    let Id = parseInt(this.props.memberType.clientId);
    axios
      .get(
        "api/v1/TransportationCompany/GetByTransportationCompanyId?TransportationCompanyId=" +
          Id,
      )
      .then((res) => {
        this.props.hideSpinner();
        if (res.data.data !== null) {
          this.setState({ TransportationCompany: res.data.data });
          console.log(res.data.data);
        } else this.setState({ alertText: res.data.errors });
      })
      .catch((error) => {
        this.props.hideSpinner();
        this.props.showAlert(showCatchError(error), "error");
        console.log(error.response);
      });
  };

  GetByProductOwnerId = () => {
    this.props.showSpinner();
    let Id = parseInt(this.props.memberType.clientId);
    axios
      .get("api/v1/ProductOwner/GetByProductOwnerId?ProductOwnerId=" + Id)
      .then((res) => {
        this.props.hideSpinner();
        if (res.data.data !== null) {
          this.setState({ ProductOwner: res.data.data });
          console.log(res.data.data);
        } else this.setState({ alertText: res.data.errors });
      })
      .catch((error) => {
        this.props.hideSpinner();
        this.props.showAlert(showCatchError(error), "error");
        console.log(error.response);
      });
  };
  GetDriverbyId = () => {
    this.props.showSpinner();
    let Id = parseInt(this.props.memberType.clientId);
    axios
      .get("api/v1/Driver/GetDriverInfo?driverId=" + Id)
      .then((res) => {
        this.props.hideSpinner();
        if (res.data.data !== null) {
          this.setState({ Driver: res.data.data });
          //console.log(res.data.data);
        } else this.setState({ alertText: res.data.errors });
      })
      .catch((error) => {
        this.props.hideSpinner();
        this.props.showAlert(showCatchError(error), "error");
        console.log(error.response);
      });
  };

  render() {
    return (
      <div className="d-flex flex-column w-100">
        {this.props.memberType.role === "TransportationCompanyAdmin" && (
          <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap w-100 mt-5">
            <FormGroup className="w-md-30 w-100 px-1">
              <Label>نام:</Label>
              {this.state.TransportationCompany.transportationCompanyName}
            </FormGroup>
            <FormGroup className="w-md-30 w-100 px-1">
              <Label>كد ملی:</Label>
              {this.state.TransportationCompany.nationalId}
            </FormGroup>
            <FormGroup className="w-md-30 w-100 px-1">
              <Label>موبایل:</Label>
              {this.state.TransportationCompany.mobile}
            </FormGroup>
          </div>
        )}
        {this.props.memberType.role === "TransportationCompanyAdmin" && (
          <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap w-100 mt-5">
            <FormGroup className="w-md-30 w-100 px-1">
              <Label>نام شهر:</Label>
              {this.state.TransportationCompany.cityName}
            </FormGroup>
            <FormGroup className="w-md-30 w-100 px-1">
              <Label>Address:</Label>
              {this.state.TransportationCompany.Address}
            </FormGroup>

            <FormGroup className="w-md-30 w-100 px-1"></FormGroup>
          </div>
        )}
        {this.props.memberType.role === "ProductOwnerAdmin" && (
          <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap w-100 mt-5">
            <FormGroup className="w-md-30 w-100 px-1">
              <Label>نام:</Label>
              {this.state.ProductOwner.firstname +
                " " +
                this.state.ProductOwner.lastname}
            </FormGroup>
            <FormGroup className="w-md-30 w-100 px-1">
              <Label>كد ملی:</Label>
              {this.state.ProductOwner.meliCode}
            </FormGroup>
            <FormGroup className="w-md-30 w-100 px-1">
              <Label>موبایل:</Label>
              {this.state.ProductOwner.mobile}
            </FormGroup>
          </div>
        )}
        {this.props.memberType.role === "Driver" && (
          <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap w-100 mt-5">
            <FormGroup className="w-md-30 w-100 px-1">
              <Label>نام:</Label>
              {this.state.Driver.name + " " + this.state.Driver.family}
            </FormGroup>
            <FormGroup className="w-md-30 w-100 px-1">
              <Label>كد ملی:</Label>
              {this.state.Driver.nationalId}
            </FormGroup>
            <FormGroup className="w-md-30 w-100 px-1">
              <Label>موبایل:</Label>
              {this.state.Driver.mobile}
            </FormGroup>
            <FormGroup className="w-md-30 w-100 px-1">
              <Label>شماره هوشمند:</Label>
              {this.state.Driver.cardNumber}
            </FormGroup>
            <FormGroup className="w-md-30 w-100 px-1"></FormGroup>
            <FormGroup className="w-md-30 w-100 px-1"></FormGroup>
          </div>
        )}
        {this.state.errors.length === 0 ? null : (
          <div>
            {this.state.errors.map((error, i) => {
              return (
                <Alert color="danger" key={i}>
                  {error}
                </Alert>
              );
            })}
          </div>
        )}
      </div>
    );
  }
}

export default profile;
